/*
 * Copyright (c) 2018-2999 广州市蓝海创新科技有限公司 All rights reserved.
 *
 * https://www.mall4j.com/
 *
 * 未经允许，不可做商业用途！
 *
 * 版权所有，侵权必究！
 */
const defaultCardPayPage = {
  MEMBER_CHARGE: 'member_charge',
  BALANCE_CHARGE: 'balance_charge',
  PAY_CHARGE: 'pay_charge'
}

// 支付类型
const PayType = {
  UNPAY: -1, // 未支付
  SCOREPAY: 0, // 积分支付
  WECHATPAY: 1, // 小程序支付
  ALIPAY: 2, // 支付宝支付
  WECHATPAY_SWEEP_CODE: 3, // 微信扫码支付
  WECHATPAY_H5: 4, // 微信H5支付
  WECHATPAY_MP: 5, // 微信公众号支付
  ALIPAY_H5: 6, // 支付宝H5支付
  ALIPAY_APP: 7, // 支付宝APP支付
  WECHATPAY_APP: 8, // 微信APP支付
  BALANCEPAY: 9, // 余额支付
  PAYPAL: 10, // paypal支付
  PLATFORM_BALANCE: 11, // 平台余额支付
  SHOP_BALANCE: 12, // 商家余额支付
  CARDPAY: 20 // 园区卡支付
}

// 支付类型展示文案，与后端 PayType 枚举保持一致
const PayTypeText = {
  [PayType.UNPAY]: '未支付',
  [PayType.SCOREPAY]: '积分支付',
  [PayType.WECHATPAY]: '微信小程序支付',
  [PayType.ALIPAY]: '支付宝',
  [PayType.WECHATPAY_SWEEP_CODE]: '微信扫码支付',
  [PayType.WECHATPAY_H5]: '微信H5支付',
  [PayType.WECHATPAY_MP]: '微信公众号支付',
  [PayType.ALIPAY_H5]: '支付宝H5支付',
  [PayType.ALIPAY_APP]: '支付宝APP支付',
  [PayType.WECHATPAY_APP]: '微信APP支付',
  [PayType.BALANCEPAY]: '余额支付',
  [PayType.PAYPAL]: 'PayPal支付',
  [PayType.PLATFORM_BALANCE]: '平台余额支付',
  [PayType.SHOP_BALANCE]: '商家余额支付',
  [PayType.CARDPAY]: '园区卡支付'
}

// 应用类型
const AppType = {
  MINI: 1, // 微信小程序
  MP: 2, // 微信公众号
  PC: 3, // pc
  H5: 4, // h5
  ANDROID: 5, // 安卓
  IOS: 6, // 苹果
  ALI: 7, // 支付宝H5
  ALIMINI: 8 // 支付宝小程序
}

// 订单状态
const OrderStatus = {
  ALL: 0, // 所有订单
  UNPAY: 1, // 待支付
  PAYED: 2, // 待发货
  CONSIGNMENT: 3, // 待收货
  SUCCESS: 5, // 已完成
  CANCEL: 6, // 已取消
  WAIT_GROUP: 7, // 待成团
  PENDING_FINAL_PAYMENT: 9 // 代付尾款
}

// 闪购订单买家侧状态
const FlashOrderStatus = {
  ALL: 0, // 所有订单
  WAIT_PAY: 1, // 待支付
  WAIT_ACCEPT: 2, // 待接单
  PREPARING: 3, // 备货中
  PREPARED: 4, // 备货完成
  WAIT_PICKUP: 5, // 待取货
  DELIVERING: 6, // 配送中
  WAIT_RECEIVE: 7, // 待收货
  DELIVERED: 8, // 已送达
  FINISHED: 9, // 已完成
  CANCELED: 10, // 已取消
  AFTER_SALE_WAIT_AUDIT: 11, // 售后待审核
  AFTER_SALE_PROCESSING: 12, // 售后中
  AFTER_SALE_REJECTED: 13 // 已拒绝售后
}

const FlashOrderStatusText = {
  [FlashOrderStatus.WAIT_PAY]: '待支付',
  [FlashOrderStatus.WAIT_ACCEPT]: '待接单',
  [FlashOrderStatus.PREPARING]: '备货中',
  [FlashOrderStatus.PREPARED]: '备货完成',
  [FlashOrderStatus.WAIT_PICKUP]: '待取货',
  [FlashOrderStatus.DELIVERING]: '配送中',
  [FlashOrderStatus.WAIT_RECEIVE]: '待收货',
  [FlashOrderStatus.DELIVERED]: '已送达',
  [FlashOrderStatus.FINISHED]: '已完成',
  [FlashOrderStatus.CANCELED]: '已取消',
  [FlashOrderStatus.AFTER_SALE_WAIT_AUDIT]: '售后待审核',
  [FlashOrderStatus.AFTER_SALE_PROCESSING]: '售后中',
  [FlashOrderStatus.AFTER_SALE_REJECTED]: '已拒绝售后'
}

const FlashOrderStatusGroups = {
  all: [],
  unpay: [FlashOrderStatus.WAIT_PAY],
  receiving: [
    FlashOrderStatus.WAIT_ACCEPT,
    FlashOrderStatus.PREPARING,
    FlashOrderStatus.PREPARED,
    FlashOrderStatus.WAIT_PICKUP,
    FlashOrderStatus.DELIVERING,
    FlashOrderStatus.WAIT_RECEIVE
  ],
  comment: [FlashOrderStatus.DELIVERED, FlashOrderStatus.FINISHED],
  completed: [FlashOrderStatus.DELIVERED, FlashOrderStatus.FINISHED],
  canceled: [FlashOrderStatus.CANCELED],
  refund: [
    FlashOrderStatus.AFTER_SALE_WAIT_AUDIT,
    FlashOrderStatus.AFTER_SALE_PROCESSING,
    FlashOrderStatus.AFTER_SALE_REJECTED
  ]
}

// 退款类型
const RefundType = {
  ALL: 1, // 整单退款
  SINGLE: 2 // 单个退款
}

// 退货退款类型
const RefundApplyType = {
  REFUND: 1, // 仅退款
  REFUND_AND_RETURNS: 2 // 退款退货
}

// 退款订单状态
const ReturnMoneySts = {
  APPLY: 1, // 退款申请中
  PROCESSING: 2, // 卖家处理退款
  CONSIGNMENT: 3, // 买家已发货
  RECEIVE: 4, // 卖家已收货
  SUCCESS: 5, // 退款成功
  FAIL: -1 // 退款关闭
}

// 退款关闭类型
const RefundCloseType = {
  CANCEL: 1, // 买家撤销退款
  DISAGREE: 2, // 卖家拒绝退款
  TIME_OUT: 3 // 退款申请超时被系统关闭
}

// 退款状态
const RefundStatus = {
  APPLY: 1, // 申请退款
  SUCCEED: 2, // 退款成功
  PARTIAL_SUCCESS: 3, // 部分退款成功
  DISAGREE: 4 // 退款失败
}

// 平台介入状态
const PlatInterveneSts = {
  APPLY: 1, // 用户申请介入
  AGREE: 2, // 平台同意介入
  REJECT: 3, // 平台拒绝介入
  REFUND_SUCCEED: 5, // 平台同意退款成功
  NONE: -1 // 没有介入
}

// 商品类型 / 订单类型
const ProdType = {
  NORMAL: 0, // 普通
  GROUP: 1, // 拼团
  SECOND: 2, // 秒杀
  SCORE: 3, // 积分
  ACTIVITY: 5 // 活动
}

// 拼团状态
const GroupStatus = {
  WAIT_PAY: 0, // 待支付
  GROUPING: 1, // 拼团中
  SUCCEED: 2, // 拼团成功
  FAIL: 3 // 拼团失败
}

// 支付入口
const PayEntry = {
  ORDER: 0, // 订单
  RECHARGE: 1, // 余额充值
  VIP: 2, // 购买vip
  FLASH_ORDER: 10 // O2O闪购订单
}

export {
  defaultCardPayPage,
  PayType,
  PayTypeText,
  AppType,
  OrderStatus,
  FlashOrderStatus,
  FlashOrderStatusText,
  FlashOrderStatusGroups,
  RefundType,
  RefundApplyType,
  ReturnMoneySts,
  RefundCloseType,
  RefundStatus,
  PlatInterveneSts,
  ProdType,
  GroupStatus,
  PayEntry
}
